import {
  faHouse,
  faEnvelope,
  faArrowAltCircleLeft,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import { appEmbedWrapperCssRules } from "../cssRules";
import { AppSpotterEmbedWrapper } from "../components/AppEmbed/AppSpotterEmbedWrapper";

const orgId: number = 1977935901;
const subDomain: string = "demov2";
const nameOfProduct: string = "Demo";
const secureRouteGroups: string[] = ["Demov2"];

export const demov2Object: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`/${subDomain}`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/spotter`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faSearch} />
            Spotter
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const demov2Routes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}/spotter`,
      element: (
        <SecureRoute
          element={
            <AppSpotterEmbedWrapper
              orgId={orgId} 
              worksheetId={"ddb66c3c-77d9-4c1c-a31c-7c71e874d1a2"}            
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={demov2Object}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};